import {
  DropdownMenu,
  IconButton,
  IconButtonSize,
  IconButtonType,
  PersonIcon,
  VistraLogo,
} from '@tricor-digital-team/vistra-design-system';
import React, { forwardRef } from 'react';
import { logout } from '../Redux/authSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = localStorage.getItem('idv_user');
  const IconBtn = forwardRef((props, ref) => {
    return (
      <IconButton
        ref={ref}
        action={props.onClick}
        icon={PersonIcon}
        size={IconButtonSize.Small}
        type={IconButtonType.Regular}
      />
    );
  });

  return (
    <nav className="shadow-lg bg-white px-28 h-[72px] border-b border-gray-200 fixed top-0 left-0 w-full z-10 flex items-center">
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <div className="flex items-center space-x-3">
            <VistraLogo extraClass="h-6" />
          </div>
          <div className="h-6 border-l border-gray-300 mx-4"></div>
          <h2 className="text-[#68696C] text-[18px]/[24px] font-medium">ECCTA compliance</h2>
        </div>
        <div>
          {userData && (
            <DropdownMenu
              items={[
                {
                  type: 'text',
                  title: 'Signed in as',
                  description: userData,
                },
                {
                  type: 'separator',
                },
                {
                  type: 'action',
                  title: 'Logout',
                  onClick: () => {
                    dispatch(logout()); // Pass the individual data to the modal
                    navigate('/login');
                  },
                },
              ]}
              menuButton={IconBtn}
            />
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
